import React from 'react';
import StorageMartCombinedHeader from './StorageMartCombinedHeader';
import compose from '../../../../../src/web/utils/react/compose';
import widget from '../../../../../src/web/components/widgets/decorators/widget';
import { NAME, ID } from './properties';
import editModal from '../../../../../src/web/components/widgets/decorators/editModal';
import Field from '../../../../../modules/react/components/stateful/Field';
import Input from '../../../../../modules/react/components/stateful/Input';
import Checkbox from '../../../../../modules/react/components/stateful/Checkbox/Checkbox';
import RadioButton from '../../../../../modules/react/components/stateful/RadioButton';

const component = compose(
  editModal(
    props => ({
      title: 'StorageMart Combined Header',
      initialValues: {
        storageMartTabPath: props.storageMartTabPath || '/',
        mmsTabPath: props.mmsTabPath || '/manhattan-mini',
        trustorageTabPath: props.trustorageTabPath || '/self-storage-management',
        mmsHeader: props.mmsHeader || false,
        hideNavigation: props.hideNavigation || false,
        logoType: props.logoType || 'storagemart',
      },
    }),
    [{
      children: [
        (<Field
          label="StorageMart Tab Path"
          name="storageMartTabPath"
          component={Input}
          help={<span>This is the path to navigate to when clicking the StorageMart tab</span>}
        />),
        (<Field
          label="MMS Tab Path"
          name="mmsTabPath"
          component={Input}
          help={<span>This is the path to navigate to when clicking the MMS tab</span>}
        />),
        (<Field
          label="truSTORAGE URL"
          name="trustorageTabPath"
          component={Input}
          help={(
            <span>
              This is the path to navigate to when clicking the truSTORAGE Property Management tab
            </span>
          )}
        />),
        (<Field
          label="Hide Navigation"
          name="hideNavigation"
          type="checkbox"
          component={Checkbox}
          help={<span>Only show the header logo</span>}
        />),
        (<Field
          label="Header Logo"
          name="logoType"
          type="radio"
          value="storagemart"
          component={RadioButton}
        >
          StorageMart Logo
         </Field>),
        (<Field
          name="logoType"
          type="radio"
          value="mms"
          component={RadioButton}
        >
          MMS Logo
         </Field>),
        (<Field
          name="logoType"
          type="radio"
          value="combined"
          component={RadioButton}
        >
          Combined Logo
         </Field>),
      ],
    }],
  ),
  widget(
    { name: NAME, category: 'Header', componentId: ID },
    {
      menu: {
        items: ['edit', 'delete'],
      },
    },
  ),
)(StorageMartCombinedHeader);

export default component;
